<template>
	<div class="omapi-datepicker-input">
		<label v-if="label">{{ label }}</label>
		<el-date-picker
			ref="datepicker"
			v-model="dateSelection"
			type="daterange"
			unlink-panels
			start-placeholder="Start date"
			end-placeholder="End date"
			format="MMM d, yyyy"
			:picker-options="pickerOptions"
			:clearable="false"
			:align="align"
			@focus="onPickerFocus"
		/>
	</div>
</template>

<script>
import { dates } from '@/utils';
import '@/components/core/form/datepicker-variables.scss';

export default {
	name: 'DatepickerInput',
	props: {
		label: {
			type: String,
			default: '',
		},
		align: {
			type: String,
			default: 'left',
		},
		openImmediate: {
			type: Boolean,
			default: false,
		},
		dateRange: {
			type: Array,
			required: true,
		},
		minDate: {
			type: Date,
			default: () => new Date(2013, 0), // When OM was started?!
		},
	},
	data() {
		return {
			activeShortcut: null,
			pickerOptions: {
				shortcuts: [
					{
						text: 'Today',
						onClick: (picker) => {
							this.setActiveShortcut('Today');
							const today = new Date();
							today.setHours(0, 0, 0, 0);
							picker.$emit('pick', [today, today]);
						},
					},
					{
						text: 'Yesterday',
						onClick: (picker) => {
							this.setActiveShortcut('Yesterday');
							const yesterday = dates.yesterday();
							picker.$emit('pick', [yesterday, yesterday]);
						},
					},
					{
						text: 'Last Week',
						onClick: (picker) => {
							this.setActiveShortcut('Last Week');
							const lw = dates.lastWeek();
							picker.$emit('pick', [lw.start, lw.end]);
						},
					},
					{
						text: 'This Month',
						onClick: (picker) => {
							this.setActiveShortcut('This Month');
							const tm = dates.thisMonth();
							picker.$emit('pick', [tm.start, tm.end]);
						},
					},
					{
						text: 'Last Month',
						onClick: (picker) => {
							this.setActiveShortcut('Last Month');
							const lm = dates.lastMonth();
							picker.$emit('pick', [lm.start, lm.end]);
						},
					},
					{
						text: 'Last 3 Months',
						onClick: (picker) => {
							this.setActiveShortcut('Last 3 Months');
							const l3m = dates.lastMonths(3);
							picker.$emit('pick', [l3m.start, l3m.end]);
						},
					},
				],
				disabledDate: this.disabledDate,
			},
		};
	},
	computed: {
		dateSelection: {
			get() {
				return this.dateRange;
			},
			set(newValue) {
				this.$emit('input', newValue);
			},
		},
	},
	mounted() {
		if (this.openImmediate) {
			this.$refs.datepicker.focus();
		}
	},
	methods: {
		disabledDate(date) {
			const time = date.getTime();

			return time > Date.now() || time < this.minDate.getTime();
		},
		setActiveShortcut(text) {
			this.activeShortcut = text;
			this.$nextTick(() => this.highlightActiveShortcut());
		},
		highlightActiveShortcut() {
			document.querySelectorAll('.el-picker-panel__shortcut').forEach((btn) => {
				btn.classList.toggle('is-active', btn.textContent.trim() === this.activeShortcut);
			});
		},
		onPickerFocus() {
			if (this.activeShortcut) {
				this.$nextTick(() => this.highlightActiveShortcut());
			}
		},
	},
};
</script>

<style lang="scss">
@import '../../../assets/scss/variables';

.omapi-datepicker-input {
	text-align: left;

	label {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 10px;
	}
}

.el-picker-panel__shortcut.is-active {
	color: $color_blue-primary;
	font-weight: 600;
	background-color: $color_blue-background;
}
</style>
